var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDjango(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228 0H28C12.536 0 0 12.536 0 28V228C0 243.464 12.536 256 28 256H228C243.464 256 256 243.464 256 228V28C256 12.536 243.464 0 228 0Z",
    fill: "#092E20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M186.378 94.198V160.425C186.378 183.244 184.708 194.188 179.7 203.65C175.061 212.742 168.939 218.491 156.325 224.799L129.796 212.184C142.411 206.248 148.532 201.055 152.428 193.075C156.51 184.913 157.81 175.452 157.81 150.593V94.198H186.378ZM140.929 50.0791V182.317C126.274 185.1 115.514 186.213 103.827 186.213C68.9497 186.213 50.7695 170.445 50.7695 140.205C50.7695 111.08 70.0639 92.1587 99.9304 92.1587C104.568 92.1587 108.092 92.5285 112.36 93.6415V50.0791H140.929ZM102.714 115.161C88.244 115.161 79.8953 124.066 79.8953 139.648C79.8953 154.861 87.873 163.209 102.529 163.209C105.681 163.209 108.279 163.023 112.36 162.468V116.643C109.021 115.532 106.239 115.161 102.714 115.161ZM186.378 50.2311V79.5424H157.81V50.2311H186.378Z",
    fill: "#FFFFFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjango);
export default __webpack_public_path__ + "static/media/django.d51a8aa4a25c4d15417346ade36e32cc.svg";
export { ForwardRef as ReactComponent };